module.exports = __webpack_public_path__ + "static/media/logo-dribbble.d4f5af0d.svg";